import api from './api.service';

export type AiAgentConfig = {
  enabled: boolean;
  allowedModules: string[];
  allowedTools: string[];
  maxRows: number;
  chartsEnabled: boolean;
  exportEnabled: boolean;
};

type GetConfigResponse = {
  success: boolean;
  companyId: string;
  config: AiAgentConfig;
};

export async function fetchAiAgentConfig(companyId?: string): Promise<GetConfigResponse> {
  const res = await api.getClient().get<GetConfigResponse>('/ai-agent/config', {
    params: { companyId: companyId || undefined },
  });
  return res.data;
}

export type HowToUsageSummary = {
  asked: number;
  answeredFromGuide: number;
  topGuides: Array<{ guideId: string; count: number }>;
  unanswered: Array<{ question: string; count: number; lastAskedAt: string; source: 'general' | 'none' }>;
};

/** GET /ai-agent/usage (super admin). Only the how-to section is typed here. */
export async function fetchHowToUsage(days = 30): Promise<HowToUsageSummary | null> {
  const res = await api.getClient().get<{ success: boolean; usage?: { howTo?: HowToUsageSummary } }>('/ai-agent/usage', {
    params: { days },
  });
  return res.data?.usage?.howTo ?? null;
}

export async function saveAiAgentConfig(payload: {
  companyId?: string;
  config: Partial<AiAgentConfig>;
}): Promise<GetConfigResponse> {
  const res = await api.getClient().put<GetConfigResponse>('/ai-agent/config', payload);
  return res.data;
}

